import './OrganizationRoles.css';

import useGetOrganizationRoles from '../../hooks/useGetOrganizationRoles';
import { Box, Chip } from '@mui/material';
import { generateClassName } from '../../../b2b-common/helpers';
import FieldComponent from '../../../b2b-common/FieldComponent';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const OrganizationRoles = ({ memberRoles = [], multiSelect = true, className = null, onUpdateRoles = null }) => {

    const { organizationRoles } = useGetOrganizationRoles();
    const { t } = useB2BTranslation('b2b-users');

    const getRoleNameById = (roleId) => {
        const role = organizationRoles.find((role) => role.roleId === roleId);
        return role ? role.roleName : '';
    };

    const handleRoleToggle = (roleId, enabled) => {
        if (!multiSelect) {
            const updatedRoles = enabled ? [{ roleId, roleName: getRoleNameById(roleId) }] : [];
            onUpdateRoles(updatedRoles);
        } else {
            const updatedRoles = enabled
                ? [...(memberRoles ?? []), { roleId, roleName: getRoleNameById(roleId) }]
                : (memberRoles ?? []).filter((role) => role.roleId !== roleId);
            onUpdateRoles(updatedRoles);
        }
    };
    
    return (
        <FieldComponent label={t('Organization roles')}
            labelAlign='left'
            className={generateClassName('organization-roles', '', className)}
            component={
                <Box className={'organization-roles-list'} display={'flex'} flexDirection={'row'} gap={3}>
                    {Array.isArray(organizationRoles) && organizationRoles.map((role) => (
                        <Chip
                            key={role.roleId}
                            label={role.roleName}
                            clickable
                            size="small"
                            color={(memberRoles ?? []).some((userRole) => userRole.roleId === role.roleId) ? 'primary' : 'default'}
                            onClick={() => handleRoleToggle(role.roleId, !((memberRoles ?? []).some((userRole) => userRole.roleId === role.roleId)))}
                        />
                    ))}                    
                </Box>
            }
            componentAlign='left'
        />
    );
}

export default OrganizationRoles;